import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Badge } from "./Badge";

interface LabelProps {
  badgeText?: string;
  badgeTooltip?: string;
  disabled?: boolean;
  title: string;
}

export const Label = ({
  title,
  badgeText,
  badgeTooltip,
  disabled,
}: LabelProps) => (
  <div className="flex w-full flex-row items-center justify-between">
    <Typography.LabelSm
      color={classNames({
        "text-tertiary": disabled,
        "text-primary": !disabled,
      })}
    >
      {title}
    </Typography.LabelSm>
    {badgeText && <Badge text={badgeText} tooltip={badgeTooltip} />}
  </div>
);
